const pad = string => (`0${string}`).slice(-2);

// istanbul ignore next
export const formatDuration = (seconds) => {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());

  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }

  return `${mm}:${ss}`;
};

// eslint-disable-next-line no-restricted-globals
export const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);

export const getElapsedBarWidth = value => `${value * 100}%`;
